function ChecklistService(ApiService) {
  'ngInject';
  const service = {};

  service.newChecklist = function (addChecklistForm, callbackFunc) {
    ApiService.post(`/base_tasks.json`, { base_task: addChecklistForm }, callbackFunc);
  };

  service.newTask = function(addTaskForm, callbackFunc) {
    ApiService.saveFile(`/base_tasks.json`, { base_task: addTaskForm }, callbackFunc);
  };

  service.updateChecklistAndTask = function (updateId, addChecklistForm, callbackFunc) {
    ApiService.updateSaveFile(`/base_tasks/${updateId}.json`, { base_task: addChecklistForm }, callbackFunc);
  };

  service.getBaseTasks = function (page, callbackFunc) {
    ApiService.get(`/base_tasks.json?page=${page}`, callbackFunc);
  };

  service.getChildTasks = function (parentId, callbackFunc) {
    ApiService.get(`/base_tasks/${parentId}/checklist_tasks.json`, callbackFunc);
  };

  service.getTaskDetails = function (taskId, callbackFunc) {
    ApiService.get(`/base_tasks/${taskId}.json`, callbackFunc);
  };

  service.deleteChecklistAndTask = function (taskId, callbackFunc) {
    ApiService.delete(`/base_tasks/${taskId}.json`, {}, callbackFunc);
  };

  service.removeImage = function (taskId, image, callbackFunc) {
    ApiService.post(`/base_tasks/${taskId}/remove_image.json`, {base_task: {image: image}}, callbackFunc);
  };

  service.rearrangeTask = function (taskId, position, callbackFunc) {
    ApiService.post(`/base_tasks/${taskId}/rearrange_task.json`, {base_task: {position: position}}, callbackFunc);
  };

  service.formParams = function(params, checklistId){
    if (checklistId) {
      params.parent_id = checklistId;
    }
    let nestedAttr = [];
    if (params.api_v1_task_attachments_attributes && params.api_v1_task_attachments_attributes.url){ 
      let add = params.api_v1_task_attachments_attributes.url;
         add.forEach(function (t) {
        nestedAttr.push({
          url: t
        });
      });
      params.attachments = nestedAttr;
      delete params.api_v1_task_attachments_attributes;
    } else {
      params.attachments = nestedAttr;
    }
    return params;
  };

  service.getOrganizations = function (callbackFunc) {
    ApiService.get(`/organizations/all_organizations.json`, callbackFunc);
  };

  service.publishChecklist = function (checklistId, data, callbackFunc) {
    ApiService.post(`/base_tasks/${checklistId}/publish.json`, { base_task: { organizations: data }}, callbackFunc);
  };

  service.addAttachment = function (taskId, data, callbackFunc) {
    ApiService.saveFile(`/base_tasks/${taskId}/add_images.json`, {files: data}, callbackFunc);
  };

  return service;
}
export default {
  name: 'ChecklistService',
  fn: ChecklistService
};